import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import { IGetRepGroupsDTO } from "../../../models/DTO/IGetRepGroupsDTO";
import IOnGetRepGroupsDTO from "../../../models/DTO/IOnGetRepGroupsDTO";
import IOnProcessSalesRepDTO from "../../../models/DTO/IOnProcessSalesRepDTO";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import IProcessSalesRepDTO from "../../../models/DTO/IProcessSalesRepDTO";
import ITypeaheadLookupByTokenTypeDTO from "../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INewSalesRep from "../../../models/INewSalesRep";
import INotification from "../../../models/INotification";
import IRepGroup from "../../../models/IRepGroup";
import ISalesRep from "../../../models/ISalesRep";
import ISupplierModel from "../../../models/ISupplierModel";
import IUser from "../../../models/IUser";
import IUserUI from "../../../models/IUserUI";
import TokenTypesEnum from "../../../models/TokenTypesEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    salesRep?: ISalesRep;
    repGroup: IRepGroup;
};

type State = {
    createActive: boolean;
    salesRep: ISalesRep;
    repGroups: IRepGroup[];
    foundUsers: IUser[];
    selectedUser?: IUser;
    performingLookup: boolean;
};

class SalesRepSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            salesRep: this.props.salesRep || ({} as ISalesRep),
            repGroups: [],
            foundUsers: [],
            performingLookup: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.RepGroupOnGetRepGroups, this.onGetRepGroups);
        this.props.socket.on(EndpointsEnum.RepGroupOnProcessSalesRep, this.onProcessSalesRep);
        this.props.socket.on(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, this.onLookupByTokenType);

        this.getRepGroups();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.RepGroupOnGetRepGroups, this.onGetRepGroups);
        this.props.socket.removeListener(EndpointsEnum.RepGroupOnProcessSalesRep, this.onProcessSalesRep);
        this.props.socket.removeListener(EndpointsEnum.TokenOnTypeaheadLookupByTokenType, this.onLookupByTokenType);
    }

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        if (this.state.selectedUser) {
            const salesRep: INewSalesRep = {
                rep_group_id: this.props.repGroup.id,
                supplier_id: this.props.supplierModel.id,
                user_id: this.state.selectedUser.id,
            };

            const payload: IProcessSalesRepDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                salesRep,
            };

            this.props.socket.emit(EndpointsEnum.RepGroupProcessSalesRep, payload);
        }
    };

    onProcessSalesRep = (data: IOnProcessSalesRepDTO) => {
        this.cancel(true);
    };

    getRepGroups = () => {
        const payload: IGetRepGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.RepGroupGetRepGroups, payload);
    };

    onGetRepGroups = (data: IOnGetRepGroupsDTO) => {
        this.setState({
            repGroups: data.repGroups,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const salesRep = this.state.salesRep;

        // @ts-expect-error
        salesRep[name] = value;

        this.setState({ salesRep });
    };

    lookupUser = (name: string) => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            tokenType: TokenTypesEnum.SUPPLIER_USER,
            isSalesRep: true,
        };

        this.props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);

        this.setState({
            performingLookup: true,
        });
    };

    onLookupByTokenType = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        if (this.state.performingLookup) {
            const foundUsers: IUser[] = data.results.map((token) => {
                return token.User!;
            });

            this.setState({
                foundUsers,
                performingLookup: false,
            });
        }
    };

    selectUser = (user: IUser) => {
        this.setState({
            selectedUser: user,
        });
    };

    render() {
        return (
            <div className={"SalesRepSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={""} title={"sales_rep"} />
                    <hr />
                </div>

                <div className={"col-12"}>
                    <div>
                        <div>
                            <OwLabel title={"rep_group"} />
                        </div>
                        {this.props.repGroup.name}
                    </div>

                    <div className={"mt-3"}>
                        <OwLabel title={"user_lookup"} />
                        <div>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.lookupUser}
                                isRequired={true}
                                typeaheadItems={this.state.foundUsers}
                                titleProp={"name"}
                                subTitleProp={"email"}
                                selectedItemFn={this.selectUser}
                                selectedItem={this.state.selectedUser}
                                selectedItemTitleProp={"name"}
                            />
                        </div>
                    </div>

                    <div className={"mt-3"}>
                        <OwButton title={"save"} fn={this.create} active={this.state.createActive} disableOnActive={true} />
                    </div>
                </div>
            </div>
        );
    }
}

export default SalesRepSidebar;
